'use strict';

var cov_1quqt7jo9g = function () {
  var path = 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\header.js',
      hash = '1e9c2ec4641cf660cb2aa870a5adc5089a611ebf',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\header.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 30
        }
      },
      '1': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 7,
          column: 7
        }
      },
      '2': {
        start: {
          line: 6,
          column: 6
        },
        end: {
          line: 6,
          column: 36
        }
      },
      '3': {
        start: {
          line: 8,
          column: 4
        },
        end: {
          line: 8,
          column: 27
        }
      },
      '4': {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 45
        }
      },
      '5': {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 47
        }
      },
      '6': {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 13,
          column: 5
        }
      },
      '7': {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 29
        }
      },
      '8': {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 17,
          column: 6
        }
      },
      '9': {
        start: {
          line: 15,
          column: 19
        },
        end: {
          line: 15,
          column: 23
        }
      },
      '10': {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 16,
          column: 57
        }
      },
      '11': {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 23,
          column: 8
        }
      },
      '12': {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 20,
          column: 84
        }
      },
      '13': {
        start: {
          line: 21,
          column: 8
        },
        end: {
          line: 21,
          column: 31
        }
      },
      '14': {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 41
        }
      },
      '15': {
        start: {
          line: 27,
          column: 0
        },
        end: {
          line: 32,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 3,
            column: 3
          }
        },
        loc: {
          start: {
            line: 3,
            column: 69
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 3
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 5,
            column: 59
          },
          end: {
            line: 5,
            column: 60
          }
        },
        loc: {
          start: {
            line: 5,
            column: 77
          },
          end: {
            line: 7,
            column: 5
          }
        },
        line: 5
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 11,
            column: 19
          },
          end: {
            line: 11,
            column: 20
          }
        },
        loc: {
          start: {
            line: 11,
            column: 31
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 11
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 14,
            column: 23
          },
          end: {
            line: 14,
            column: 24
          }
        },
        loc: {
          start: {
            line: 14,
            column: 37
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 14
      },
      '4': {
        name: 'buildToggler',
        decl: {
          start: {
            line: 18,
            column: 13
          },
          end: {
            line: 18,
            column: 25
          }
        },
        loc: {
          start: {
            line: 18,
            column: 39
          },
          end: {
            line: 24,
            column: 5
          }
        },
        line: 18
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 19,
            column: 13
          },
          end: {
            line: 19,
            column: 14
          }
        },
        loc: {
          start: {
            line: 19,
            column: 24
          },
          end: {
            line: 23,
            column: 7
          }
        },
        line: 19
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 20,
            column: 8
          },
          end: {
            line: 20,
            column: 83
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 20,
            column: 35
          },
          end: {
            line: 20,
            column: 58
          }
        }, {
          start: {
            line: 20,
            column: 61
          },
          end: {
            line: 20,
            column: 83
          }
        }],
        line: 20
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0
    },
    b: {
      '0': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HeaderController =
/** @ngInject */
function HeaderController($scope, $window, $mdSidenav, $rootScope, $http, myVars) {
  _classCallCheck(this, HeaderController);

  ++cov_1quqt7jo9g.f[0];
  ++cov_1quqt7jo9g.s[0];

  $scope.checkinfo = myVars;
  ++cov_1quqt7jo9g.s[1];
  $http.get($rootScope.apiOpen + 'categories/list').then(function (result) {
    ++cov_1quqt7jo9g.f[1];
    ++cov_1quqt7jo9g.s[2];

    $scope.menuData = result.data;
  });
  ++cov_1quqt7jo9g.s[3];
  $scope.showMenu = true;
  ++cov_1quqt7jo9g.s[4];
  $scope.toggleLeft = buildToggler('left');
  ++cov_1quqt7jo9g.s[5];
  $scope.toggleRight = buildToggler('right');
  ++cov_1quqt7jo9g.s[6];
  $scope.totop = function () {
    ++cov_1quqt7jo9g.f[2];
    ++cov_1quqt7jo9g.s[7];

    $window.scrollTo(0, 0);
  };
  ++cov_1quqt7jo9g.s[8];
  $scope.showLogin = function (ev) {
    ++cov_1quqt7jo9g.f[3];

    var data = (++cov_1quqt7jo9g.s[9], true);
    ++cov_1quqt7jo9g.s[10];
    $rootScope.$emit('CallMethodRegister', { ev: ev, data: data });
  };
  function buildToggler(componentId) {
    ++cov_1quqt7jo9g.f[4];
    ++cov_1quqt7jo9g.s[11];

    return function () {
      ++cov_1quqt7jo9g.f[5];
      ++cov_1quqt7jo9g.s[12];

      $scope.showMenu === true ? (++cov_1quqt7jo9g.b[0][0], $scope.showMenu = false) : (++cov_1quqt7jo9g.b[0][1], $scope.showMenu = true);
      ++cov_1quqt7jo9g.s[13];
      $window.scrollTo(0, 0);
      ++cov_1quqt7jo9g.s[14];
      $mdSidenav(componentId).toggle();
    };
  }
};

++cov_1quqt7jo9g.s[15];

angular.module('app').component('fountainHeader', {
  templateUrl: 'app/header.html',
  controller: HeaderController
});